import React, {Component} from 'react'


class App extends Component {

    constructor() {
      super();
      this.state = {seconds: 0, name: "", city: "", count: ""};
      this.handleClick = this.handleClick.bind(this);

      fetch('/welcome/org')
        .then(response => response.json())
        .then(name => this.setState(state => ({name: name})));

      fetch('/welcome/info')
        .then(response => response.json())
        .then(info => {
            if (info["status"] === "fail") {
                this.setState(state => ({city: "your city"}));
            } else {
                this.setState(state => ({city: info["city"]}));
            }
        })

      fetch('/welcome/count')
        .then(response => response.json())
        .then(data =>
            {
            var count = data === 1 ? 'first'  :
                        data === 2 ? 'second' :
                        data === 3 ? 'third'  :
                                  '' + data + '-th';
            this.setState(state => ({count: count}));
            });
    }

    tick() {
      this.setState(state => ({seconds: state.seconds + 1}));
    }

    handleClick() {
      this.setState(state => ({seconds: 0}));
    }

    componentDidMount() {
      this.interval = setInterval(() => this.tick(), 1000);
    }

    componentWillUnmount() {
      clearInterval(this.interval);
    }

    render() {
      return (
        <div>
          Welcome to {this.state.name}! This is your {this.state.count} visit to our site!
          <p/>
          How's the weather in {this.state.city}?
          <p/>
          <button onClick={this.handleClick}>Reset timer</button>
          <p/>
          Timer:{this.state.seconds}
        </div>
        );
    }
}

export default App
